import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { pure } from '@dbk/ui-react-utils';
import format from 'date-fns/format';
import { Currency, ChangeIndicatedPercent } from '../../../../../../src/components/common/number';

import Text from '../../../../../../src/components/common/text';
import { NO_DATA } from '../../../constants';
import styles from './market-value-header.styles';

function MarketValueHeader({
  marketValue,
  marketValueAsOfDate, 
  marketValueUnit,
  dayChange,
  dayChangeUnit,
  dayChangePercentage,
  dayChangeVisible,
  marketLabelText,
  twrr,
  messages,
  location
}) {

  const asOfDate = marketValueAsOfDate? format(marketValueAsOfDate , 'DD.MM.YYYY'): '';

  return (
  
    
      <div  className="marketContainer" testID="market-value-container">
        <div className= "marketValueColumn" >
        <View id="market-value-label">
            <Text type="primary" style={styles.marketValueLabel}>{messages['app.portfolio.assetHeader.total.title']}{asOfDate}
            </Text>
          </View>
        {marketValueUnit&&<Currency
            signBeforeNumber={false}
            decimalStyle={styles.decimalStyle}
            currencyStyle = {styles.currencyStyle}
            currency={marketValueUnit}
            renderProps={{
              style: styles.marketValueText,
              size: 40,
              testID: 'market-value',
            }}
            value={marketValue}
          />}

        </div>

      
        {location.endsWith('/portfolios') && dayChangeVisible && 
        <div className="dayChangeContainer" testID="day-change-container">
          <Text type="normal" style={styles.dayChangeText} >{messages['app.portfolio.listassets.dayChange']}</Text>
        <div className="marketContainer marginTop">
        {dayChange !=null && <div style={{display:'flex',alignItems:'center'}}>
          <Currency
            signBeforeNumber={false}
            renderProps={{
              style : styles.dayChangeValue,
              size: 19,
              testID: 'day-change',
            }}
            currency = {dayChangeUnit}
            value={dayChange}
          />
          </div>}
          {dayChangePercentage != null && <ChangeIndicatedPercent
            renderProps={{
              style: styles.changeIndicatedPercent,
              testID: 'day-change-percentage',
            }}
            value={dayChangePercentage}
            withPlusSign
          />}
        </div>
      </div>}
      {/* render TWRR value */}
      {location.endsWith('/portfolios') &&
       <div className="twrrValueContainer">
       <div id="day-change-label" className="marketContainer">
          <Text type="normal"  style={styles.twrrText} >{messages['app.portfolio.listassets.TWRR']}</Text>
        </div>
        {twrr&&<div className="marketContainer marginTop">
          <ChangeIndicatedPercent
            renderProps={{
              style: styles.twrrIndicatedPercent,
              testID: 'day-change-percentage',
            }}
            value={twrr[0].performanceTWRR}
            withPlusSign
          />
        </div>}
         </div>}
      </div>

      
  );
}

MarketValueHeader.propTypes = {
  marketValue: PropTypes.number,
  marketValueUnit: PropTypes.string,
  dayChange: PropTypes.number,
  dayChangeUnit: PropTypes.string,
  dayChangePercentage: PropTypes.number,
  dayChangeVisible: PropTypes.bool,
  marketLabelText: PropTypes.string,
  twrr:PropTypes.array,
};

MarketValueHeader.defaultProps = {
  dayChangeVisible: true,
  marketLabelText: 'Market Value',
};

export default pure(MarketValueHeader);
